import { generateTicketHash } from "@qoohoo/common/utils/crypto";
import useCustomerStore from "store/customerStore";
import usePreferencesStore from "store/preferencesStore";

export default function getMailTo({ query,  }) {
    const parentUrl = usePreferencesStore.getState().preferences.data.parentUrl;
    const customer = useCustomerStore.getState().customer?.data;

    const ticketHash = generateTicketHash();
    
    const mailToSubject = `[Support]: ${query} | Ticket #${ticketHash}`;
    let mailToBody = 
`Hi team,  
  
I am doing payment on page ${parentUrl}
Add more details below:


Thanks
`;

    let userInfo;

    if(customer) {
        userInfo = 
`
Name: ${customer.name}
Username: ${customer.username}
Phone: ${customer.mobile}`;
        
    } else {
        userInfo = 
        `
Name:
Phone:`;
    }
    
    mailToBody = mailToBody.concat(userInfo);
  
    const subject = encodeURIComponent(mailToSubject);
    const body = encodeURIComponent(mailToBody);

    return `mailto:support@qoohoo.in?subject=${subject}&body=${body}`;
}